import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './CookieConsent.css';

// Cookie utility functions
const setCookie = (name, value, days = 365) => {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/`;
};

const getCookie = (name) => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

const CookieConsent = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user has already accepted/declined cookies using browser cookies
    const cookieConsent = getCookie('cookieConsent');
    
    // Show if no cookie exists (works on both desktop and mobile)
    if (!cookieConsent) {
      // Small delay to ensure smooth appearance
      setTimeout(() => {
        setShow(true);
      }, 1000);
    }
  }, []);

  const handleAccept = () => {
    // Store in browser cookie with 1 year expiration
    setCookie('cookieConsent', 'accepted', 365);
    setShow(false);
  };

  const handleDecline = () => {
    // Store in browser cookie with 1 year expiration
    setCookie('cookieConsent', 'declined', 365);
    setShow(false);
  };

  const handleCookiePolicyClick = () => {
    navigate('/privacy-policy');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="cookie-consent-container">
      <div className="cookie-consent-card">
        <div className="cookie-consent-content">
          <div className="cookie-consent-text">
            <h3>We use cookies</h3>
            <p>We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. By clicking "Accept", you consent to our use of cookies.</p>
          </div>
        </div>
        <div className="cookie-consent-actions">
          <button 
            type="button" 
            className="cookie-btn cookie-btn-secondary"
            onClick={handleDecline}
          >
            Decline
          </button>
          <button 
            type="button" 
            className="cookie-btn cookie-btn-primary"
            onClick={handleAccept}
          >
            Accept
          </button>
        </div>
        <button 
          type="button" 
          className="cookie-policy-link"
          onClick={handleCookiePolicyClick}
        >
          Learn more about our Cookie Policy
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
